import { AlertTriangle } from "react-feather";

// Aviso de golpe no topo. No celular vai a versão curta (a longa ocupava
// cinco linhas e empurrava o rastreio pra baixo da dobra).
export default function WarningBanner() {
  return (
    <div className="border-b border-red-200 bg-red-50 text-red-800">
      <p className="mx-auto max-w-7xl px-4 py-1.5 text-center text-xs leading-snug">
        <AlertTriangle className="-mt-0.5 mr-1.5 inline h-3.5 w-3.5 align-middle" />
        <strong className="font-semibold">Cuidado com golpes!</strong>
        <span className="sm:hidden"> A beuni nunca cobra taxa para liberar a sua entrega.</span>
        <span className="hidden sm:inline">
          {" "}
          A beuni e suas transportadoras parceiras nunca cobram taxas extras após a compra para a liberação da sua carga. Não clique em links
          suspeitos nem realize pagamentos não solicitados. Em caso de dúvida, contate nosso suporte.
        </span>
      </p>
    </div>
  );
}
